<template>
  <v-card>
    <v-container class="py-0">
      <v-card-title class="text-h5 mt-2 px-0">
        <v-row class="py-0">
          <v-col class="pt-1 pb-0">
            <v-card-actions class="px-0 py-0">
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                @click="closeDialog(false)"
                :icon="closeIcon"
                variant="text"
                id="v-btn-close-envio-usuarios"
              >
              </v-btn>
            </v-card-actions>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="pb-2 pt-0">
            Seleccionar usuarios para envío de credenciales
          </v-col>
        </v-row>
      </v-card-title>

      <v-card-text class="px-0 pt-3">
        <!-- Combo de financiadores para admin -->
        <div v-if="shouldShowFinanciadorCombo">
          <v-autocomplete
            v-model="selectedFinanciadores"
            :items="financiadores"
            item-title="value1"
            item-value="id"
            label="Seleccionar financiadores"
            multiple
            variant="outlined"
            chips
            clearable
            :loading="isLoadingFinanciadores"
            @update:model-value="onFinanciadoresChange"
            id="v-autocomplete-financiadores"
            class="mb-3"
          >
            <template v-slot:chip="{ props, item }">
              <v-chip
                v-bind="props"
                size="small"
                color="primary"
                variant="outlined"
                closable
                @click:close="removeFinanciador(item.raw.id)"
              >
                {{ item.raw.value }}
              </v-chip>
            </template>
          </v-autocomplete>
        </div>
        <v-card class="elevation-1">
          <v-container class="mobile-container">
            <v-row>
              <v-col cols="12" class="py-0">
                <v-text-field
                  v-model="search"
                  label="Buscar usuario"
                  density="compact"
                  variant="underlined"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
          <v-data-table
            v-model="selectedUsersObjects"
            :headers="headers"
            :items="filteredUsers"
            :loading="isLoadingUsers"
            show-select
            item-value="userId"
            :search="search"
            class="elevation-1"
            :items-per-page="10"
            :items-per-page-options="[10, 25, 50]"
            id="v-data-table-usuarios"
            density="compact"
          >
            <template v-slot:[`item.userName`]="{ item }">
              <div class="font-weight-medium">
                {{ item.userName }}
              </div>
            </template>

            <template v-slot:[`item.email`]="{ item }">
              <div class="text-body-2">
                {{ item.email || "Sin email" }}
              </div>
            </template>

            <template v-slot:[`item.grupoUsuario`]="{ item }">
              <v-chip size="small" color="primary" variant="tonal">
                {{ item.grupoUsuario?.value || "Sin grupo" }}
              </v-chip>
            </template>

            <template v-slot:no-data>
              <div class="text-center pa-4">
                <p class="text-body-1 text-grey-600">
                  No hay usuarios disponibles para envío de credenciales
                </p>
              </div>
            </template>

            <template v-slot:loading>
              <div class="text-center pa-4">
                <v-progress-circular
                  indeterminate
                  color="primary"
                ></v-progress-circular>
                <p class="mt-2 text-body-2">Cargando usuarios...</p>
              </div>
            </template>
          </v-data-table>
        </v-card>
        <!-- Mostrar usuarios seleccionados -->
        <div v-if="selectedUsersObjects.length > 0" class="mt-4">
          <h6 class="text-h6 mb-2">
            Usuarios seleccionados ({{ selectedUsersObjects.length }})
          </h6>
        </div>

        <v-card-actions class="justify-end pr-0 mt-3">
          <v-btn
            color="primary"
            @click="confirmarEnvio"
            :disabled="
              !selectedUsersObjects ||
              selectedUsersObjects.length === 0 ||
              isLoadingEnvio
            "
            :loading="isLoadingEnvio"
            id="v-btn-enviar-credenciales-usuarios"
          >
            Enviar credenciales ({{ selectedUsersObjects.length }})
          </v-btn>
        </v-card-actions>
      </v-card-text>
    </v-container>
  </v-card>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import enums from "@/utils/enums/index";

export default {
  name: "SeleccionarUsuarioEnvioCredenciales",
  data() {
    return {
      selectedUsersObjects: [],
      closeIcon: enums.icons.CLOSE_ICON,
      isLoadingEnvio: false,
      availableUsers: [],
      isLoadingUsers: false,
      userLoggedType: null,
      selectedFinanciadores: [],
      financiadores: [],
      isLoadingFinanciadores: false,
      search: "",
      headers: [
        {
          title: "Usuario",
          key: "userName",
          align: "start",
          sortable: true,
        },
        {
          title: "Razón social",
          key: "entidadNombre",
          align: "start",
          sortable: true,
        },
        {
          title: "Email",
          key: "email",
          align: "start",
          sortable: true,
        },
        {
          title: "Grupo",
          key: "grupoUsuario",
          align: "center",
          sortable: true,
        },
      ],
    };
  },
  computed: {
    ...mapGetters({ isMobile: "menu/isMobile" }),
    canConfirm() {
      return this.selectedUsersObjects.length > 0;
    },
    isAdmin() {
      return this.userLoggedType?.esAdmin === true;
    },
    shouldShowFinanciadorCombo() {
      return this.isAdmin && this.financiadores.length > 0;
    },
    filteredUsers() {
      // Si es admin y no ha seleccionado financiadores, no mostrar usuarios
      if (this.isAdmin && this.selectedFinanciadores.length === 0) {
        return [];
      }
      return this.availableUsers;
    },
  },
  async created() {
    await this.getUserLoggedType();
    if (this.isAdmin) {
      await this.loadFinanciadores();
    } else {
      // Si no es admin, cargar usuarios de su financiador inmediatamente
      await this.loadAvailableUsers();
    }
  },
  methods: {
    ...mapActions({
      enviarCredencialesPorUsuarios:
        "financiador/enviarCredencialesPorUsuarios",
      setAlert: "user/setAlert",
      getUsuarios: "user/getUsuarios",
      getFiltersByUser: "solicitud/getFiltersByUser",
      getFinanciadores: "taxonomy/getFinanciadores",
    }),
    async getUserLoggedType() {
      try {
        const userLogged = await this.getFiltersByUser();
        this.userLoggedType = userLogged;
      } catch (error) {
        this.setAlert({
          type: "error",
          message: "Error al cargar los datos del usuario.",
        });
        console.error("Error al cargar datos del usuario:", error);
      }
    },
    async loadFinanciadores() {
      this.isLoadingFinanciadores = true;
      try {
        this.financiadores = await this.getFinanciadores();
      } catch (error) {
        this.setAlert({
          type: "error",
          message: "Error al cargar los financiadores.",
        });
        console.error("Error al cargar financiadores:", error);
      }
      this.isLoadingFinanciadores = false;
    },
    async loadAvailableUsers() {
      this.isLoadingUsers = true;
      try {
        // Si no es admin, cargar usuarios de su financiador
        if (!this.isAdmin) {
          const payload = {
            financiadorId: this.userLoggedType?.financiadorId,
          };
          const usuarios = await this.getUsuarios(payload);
          this.availableUsers = usuarios;
        }
        // Si es admin, este método se llamará desde onFinanciadoresChange
      } catch (error) {
        this.setAlert({
          type: "error",
          message: "Error al cargar los usuarios.",
        });
        console.error("Error al cargar usuarios:", error);
      }
      this.isLoadingUsers = false;
    },
    async loadUsuariosByFinanciador(financiadorId) {
      try {
        const payload = { financiadorId };
        const usuarios = await this.getUsuarios(payload);

        // Agregar usuarios nuevos sin duplicar
        usuarios.forEach((usuario) => {
          const existe = this.availableUsers.find(
            (u) => u.userId === usuario.userId
          );
          if (!existe) {
            this.availableUsers.push(usuario);
          }
        });
      } catch (error) {
        this.setAlert({
          type: "error",
          message: `Error al cargar usuarios del financiador ${financiadorId}.`,
        });
        console.error("Error al cargar usuarios por financiador:", error);
      }
    },
    async onFinanciadoresChange(newValue) {
      // Limpiar selección de usuarios cuando cambien los financiadores
      this.selectedUsersObjects = [];
      if (!this.isAdmin) return;

      const currentFinanciadores = newValue || [];

      // Limpiar todos los usuarios disponibles
      this.availableUsers = [];

      // Si no hay financiadores seleccionados, no cargar nada
      if (currentFinanciadores.length === 0) return;

      // Cargar usuarios de todos los financiadores seleccionados desde cero
      this.isLoadingUsers = true;
      try {
        for (const financiadorId of currentFinanciadores) {
          await this.loadUsuariosByFinanciador(financiadorId);
        }
      } catch (error) {
        this.setAlert({
          type: "error",
          message:
            "Error al cargar usuarios de los financiadores seleccionados.",
        });
        console.error("Error en onFinanciadoresChange:", error);
      }
      this.isLoadingUsers = false;
    },
    removeFinanciador(financiadorId) {
      const newSelection = this.selectedFinanciadores.filter(
        (id) => id !== financiadorId
      );
      this.selectedFinanciadores = newSelection;
    },
    closeDialog() {
      this.$emit("closeDialog");
    },
    async confirmarEnvio() {
      if (!this.canConfirm) return;

      this.isLoadingEnvio = true;
      try {
        const response = await this.enviarCredencialesPorUsuarios(
          this.selectedUsersObjects
        );

        // Verificar si hay usuarios con errores
        const usuariosConError = response.filter((usuario) => !usuario.enviado);
        const usuariosExitosos = response.filter((usuario) => usuario.enviado);

        if (usuariosConError.length > 0) {
          // Hay errores - mostrar mensaje
          this.setAlert({
            type: "warning",
            message: `Credenciales enviadas a ${
              usuariosExitosos.length === 1
                ? "1 usuario"
                : `${usuariosExitosos.length} usuarios`
            }. ${
              usuariosConError.length === 1
                ? "1 usuario"
                : `${usuariosConError.length} usuarios`
            } tuvieron errores.`,
          });
        } else {
          // Todo exitoso
          this.setAlert({
            type: "success",
            message: `Credenciales enviadas exitosamente a ${
              response.length === 1
                ? "1 usuario"
                : `${response.length} usuarios`
            }.`,
          });
        }

        // Cerrar el diálogo
        this.closeDialog();
      } catch (error) {
        this.setAlert({
          type: "error",
          message: `${error.response.data.errors}`,
        });
        console.error("Error al enviar credenciales:", error);
      }
      this.isLoadingEnvio = false;
    },
  },
};
</script>

<style scoped></style>
